import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Icon } from "@/components/Icon";

export interface BreadcrumbItem {
    label: React.ReactNode;
    to?: string;
    current?: boolean;
    onClick?: () => void;
}

export interface BreadcrumbProps {
    items: BreadcrumbItem[];
    align?: "left" | "center" | "right";
    className?: string;
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({
    items,
    align = "left",
    className = "",
}) => {
    const { t } = useTranslation("global");
    const homeLabel = t("workspace.home");
    const breadcrumbClassName =
        "app-breadcrumb app-breadcrumb-" + align + " " + className;
    if(items.length === 0){
        return null;
    }

    return (
        <nav className={breadcrumbClassName.trim()} aria-label={homeLabel}>
            <Link to="/" aria-label={homeLabel} className="app-breadcrumb-home">
                <Icon value="house" size={16} />
            </Link>
            {items.map((item, index) => (
                <div
                    className="app-breadcrumb-item"
                    key={`${index}-${String(item.label)}`}
                >
                    <Icon
                        value="chevronRight"
                        size={12}
                        className="app-breadcrumb-separator"
                    />
                    {item.onClick ? (
                        <button
                            type="button"
                            className="app-breadcrumb-menu-trigger"
                            onClick={item.onClick}
                        >
                            {item.label}
                        </button>
                    ) : item.to && !item.current ? (
                        <Link to={item.to} className="app-breadcrumb-link">
                            {item.label}
                        </Link>
                    ) : (
                        <div
                            aria-current={
                                item.current || index === items.length - 1
                                    ? "page"
                                    : undefined
                            }
                            className={
                                item.current || index === items.length - 1
                                    ? "app-breadcrumb-current"
                                    : ""
                            }
                        >
                            {item.label}
                        </div>
                    )}
                </div>
            ))}
        </nav>
    );
};

